// Module
var code = "<ol start=\"7\"> <li> <strong>Total paid since your last statement:</strong> The total amount of your last payment, which is the sum of the interest, principal, and fees.</li> </ol> ";
// Exports
export default code;